/* eslint-disable */
import React, { useEffect, useState } from "react";
import BossDialog from "../../components/BossDialog";
import * as API from "../../framework/API/api";
import { ENTITYNAME, EMAIL_TEMPLATE_TYPE, MODULE, TOAST_TYPES } from "../../framework/constant/constant";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { EditPageHeader } from "../../components/EditPageHeader";
import ReactQuill from "react-quill";
import AddRoundButton from "../../framework/forms/helpercomponents/buttons/AddRoundButton";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import RoundButton from "../../framework/forms/helpercomponents/buttons/RoundButton";
import DeleteRoundButton from "../../framework/forms/helpercomponents/buttons/DeleteRoundButton";
import { ConfirmDeleteAlert } from "../../ConfirmAlert";
import { utility } from "../../framework/utility/utilityProvider";
import { useTranslation } from "../../locale/useTranslation";
import ToastNotification from "../../components/ToastNotification";

export const SendEmailForm = (props) => {
    const lang = useTranslation();
    const [dataItem, setDataItem] = useState({});
    const [emailTemplates, setEmailTemplates] = useState([]);
    const [emailTemplate, setEmailTemplate] = useState({});
    const [senders, setSenders] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    console.log(props)

    useEffect(() => {
        loadCombo();
        loadEmailData(props.mailData);
    }, []);

    const loadCombo = async () => {
        let senderRes = await API.getDataLookup(ENTITYNAME.EmailConfiguration);
        setSenders(senderRes.data);
    };

    const loadEmailData = async (mailData) => {
        let query = [];
        if (mailData?.TemplateModule) {
            query.push(["TemplateModule", "=", mailData?.TemplateModule]);
        }
        let templateRes = await API.getDataLookup(ENTITYNAME.EmailTemplate, { query });
        setEmailTemplates(templateRes.data);
        let defaultTemplateRes = utility.getDefaultItems(templateRes.data);
        let defaultTemplate = defaultTemplateRes[0];
        console.log(defaultTemplate)
        setEmailTemplate(defaultTemplate)
        let senderRes = await API.getDataLookup(ENTITYNAME.EmailConfiguration);
        setSenders(senderRes.data);
        setDataItem({
            ...dataItem,
            ...defaultTemplate,
            Subject: defaultTemplate?.Subject ?? "",
            Body: defaultTemplate?.Body ?? "",
            ...((Object.keys(mailData).length > 0) ? { To: mailData?.To ?? "", CC: mailData?.CC ?? "" } : {}),
            Attachments: [
                ...(defaultTemplate?.Attachments?.length > 0 ? defaultTemplate?.Attachments : []),
                ...(mailData?.Attachments?.length > 0 ? mailData.Attachments.map(x => ({ fileName: x, File: x })) : [])
            ],
        });
    };

    const isValid = () => {
        if ((Object.keys(emailTemplate).length === 0 || !emailTemplate)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_select_email_template_error_message}` });
            return false;
        }
        if ((Object.keys(dataItem.Sender).length === 0 || !dataItem.Sender)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_select_sender_error_message}` });
            return false;
        }
        if (!dataItem.To || dataItem.To === "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_enter_to_error_message}` });
            return false;
        }
        if (!dataItem.Subject || dataItem.Subject === "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_enter_subject_error_message}` });
            return false;
        }
        if (!dataItem.Body || dataItem.Body === "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_enter_body_error_message}` });
            return false;
        }
        return true;
    }

    const getValueFromObject = (obj, path) => {
        return path.split('.').reduce((acc, part) => acc?.[part], obj);
    };


    const handleSubmit = async () => {
        if (!isValid()) return;
        setIsLoading(true);

        let recipientData = props.mailData;
        let emailBody = dataItem.Body ?? "";

        emailBody = emailBody.replace(/{(.*?)}/g, (match, key) => {
            const value = getValueFromObject(recipientData, key);
            return value ?? match;
        });

        const emailPayload = {
            Service: dataItem.Sender?.Service ?? "gmail",
            From: dataItem.Sender?.Email,
            AppPass: dataItem.Sender?.AppPass,
            To: dataItem.To,
            CC: dataItem.CC,
            BCC: dataItem.BCC,
            Subject: dataItem.Subject,
            Body: emailBody,
            Attachments: Array.isArray(dataItem.Attachments)
                ? dataItem.Attachments.map(x => x.File)
                : [],
            Sender: dataItem.Sender
        };

        let res = await API.sendEmail(emailPayload);

        if (res?.success) {
            setIsLoading(false);
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.email_sent_success_message });
            props.cancelEdit();
        } else {
            setIsLoading(false);
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.error_sending_email_message });
        }
    };

    const onChange = (e) => {
        const { name, value } = e.target;
        setDataItem({ ...dataItem, [name]: value });
    };

    const onFileChange = async (e) => {

        const files = Array.from(e.target.files || []);
        if (!files.length) return;

        const existingFileNames = Array.isArray(dataItem.Attachments)
            ? dataItem.Attachments.map(file => file.fileName)
            : [];

        const filteredFiles = files.filter(file => {
            if (existingFileNames.includes(file.name)) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.file_already_attached_error_message })
                return false;
            }
            return true;
        });

        if (!filteredFiles.length) {
            e.target.value = '';
            return;
        }

        try {

            const uploadedAttachments = [];

            for (let file of filteredFiles) {

                let uploadRes = await API.uploadFile(file);

                if (!uploadRes?.success) {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: uploadRes?.message || lang.unable_to_upload_file_error_message })
                    continue;
                }

                uploadedAttachments.push({
                    fileName: file.name,
                    File: uploadRes.data,
                });
            }

            setDataItem(prev => ({
                ...prev,
                Attachments: [
                    ...(Array.isArray(prev.Attachments) ? prev.Attachments : []),
                    ...uploadedAttachments
                ]
            }));

            e.target.value = '';

        } catch (error) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.unable_to_upload_file_error_message });
        }
    };

    const deleteAttachment = async (rowData) => {

        ConfirmDeleteAlert(async () => {

            try {
                let res = await API.deleteFile(rowData.fileName);

                if (res?.success) {
                    setDataItem(prev => ({
                        ...prev,
                        Attachments: prev.Attachments.filter(
                            (_, index) => index !== rowData._index
                        )
                    }));
                    ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.deleted_success_message });
                } else {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res?.message || lang.unable_to_delete_file_error_message });
                }

            } catch (error) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.unable_to_delete_file_error_message });
            }

        }, () => { });
    };

    const downloadAttachment = async (rowData) => {

        try {
            const filePathRes = await API.readFileNameWithContent(rowData.fileName);

            if (filePathRes.success) {
                let fileUrl = filePathRes.filePath.split('/').pop();
                await API.downloadFile(fileUrl);
            }

        } catch (error) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.unable_to_download_file_error_message });
        }
    };

    const MyCommandCell = (props) => (
        <td>
            <RoundButton icon="download" onClick={() => downloadAttachment(props.dataItem)} />
            <DeleteRoundButton onClick={() => deleteAttachment(props.dataItem)} />
        </td>
    );

    return (
        <BossDialog
            title={"Send Email"}
            onClose={props.cancelEdit}
            width={"900px"}
        >
            <EditPageHeader
                showTitle={false}
                onSubmit={handleSubmit}
                onCancel={props.cancelEdit}
                isLoading={isLoading}
                saveButtonTitle={lang.send_button_tooltip}
            />

            <div className="row mt-2 form-group">
                <div className="col-6">
                    <label>Email Template *</label>
                    <DropDownList
                        data={emailTemplates}
                        name="Template"
                        textField="Description"
                        dataItemKey="_id"
                        value={emailTemplate}
                        onChange={(e) => {
                            const selectedTemplate = e.target.value;
                            setEmailTemplate(selectedTemplate);
                            setDataItem((prev) => ({
                                ...prev,
                                ...selectedTemplate,
                            }));
                        }}
                    />
                </div>

                <div className="col-6">
                    <label>{lang.sender_label} *</label>
                    <DropDownList
                        data={senders}
                        name="Sender"
                        textField="Email"
                        dataItemKey="_id"
                        value={dataItem.Sender}
                        onChange={onChange}
                    />
                </div>
            </div>

            <div className="row mt-2 form-group">
                <div className="col-6">
                    <label>{lang.to_label} *</label>
                    <input
                        name="To"
                        className="form-control form-control-sm"
                        value={dataItem.To}
                        onChange={onChange}
                    />
                </div>
                <div className="col-6">
                    <label>{lang.subject_label} *</label>
                    <input
                        name="Subject"
                        className="form-control form-control-sm"
                        value={dataItem.Subject}
                        onChange={onChange}
                    />
                </div>
            </div>

            <div className="row mt-2 form-group">
                <div className="col-6">
                    <label>{lang.cc_label}</label>
                    <input
                        name="CC"
                        className="form-control form-control-sm"
                        value={dataItem.CC}
                        onChange={onChange}
                    />
                </div>
                <div className="col-6">
                    <label>{lang.bcc_label}</label>
                    <input
                        name="BCC"
                        className="form-control form-control-sm"
                        value={dataItem.BCC}
                        onChange={onChange}
                    />
                </div>
            </div>

            <div className="row mt-3">
                <div className="col-12">
                    <label>{lang.body_label}</label>
                    <ReactQuill
                        theme="snow"
                        value={dataItem.Body}
                        onChange={(content) =>
                            setDataItem({ ...dataItem, Body: content })
                        }
                        style={{ height: "200px", marginBottom: "40px" }}
                    />
                </div>
            </div>

            <div className="row mt-4">
                <div className="col-12">

                    <div className='d-flex justify-content-between align-items-center'>
                        <AddRoundButton
                            name="Add Attachment"
                            onClick={() => document.getElementById('fileInput').click()}
                            title="Add"
                            icon="plus"
                        />
                        <input
                            type="file"
                            id="fileInput"
                            multiple
                            onChange={onFileChange}
                            style={{ display: 'none' }}
                        />
                        <div>{lang.attachments_label}</div>
                    </div>

                    <Grid
                        style={{ height: "200px", marginTop: "5px" }}
                        data={dataItem?.Attachments?.length > 0 ? dataItem.Attachments.map((file, i) => ({
                            ...file,
                            _index: i
                        })) : []}
                    >
                        <GridColumn cell={MyCommandCell} width="100px" />
                        <GridColumn field="fileName" title={lang.file_name_column} />
                    </Grid>

                </div>
            </div>

        </BossDialog>
    );
};